import { connect } from 'react-redux';
import DndDraggable from '../components/dnd-draggable';

const mapStateToProps = state => ({
  isDraggingOver: state.gantt.isDraggingOver,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(DndDraggable);
